export enum DiseaseRiskStatusEnum {
  ERROR = 'ERROR',
  OK = 'OK'
}

export enum RegionalOverviewSource {
  QUALIMETRE = 'QUALIMETRE',
  DISEASE_RISK = 'DISEASE_RISK',
  GRID_VIEW = 'GRID_VIEW',
  DIGITAL_TRAPS = 'DIGITAL_TRAPS',
  INOCULUM_SURVIVAL = 'INOCULUM_SURVIVAL',
  ABIOTIC_STRESS = 'ABIOTIC_STRESS'
}

export enum RiskLevelEnum {
  MISSING_CONFIG = -1,
  LOW = 0,
  MEDIUM = 1,
  HIGH = 2,
  NO_RISK = 3
}

export enum RegionalOverviewQueryType {
  GET_REGIONAL_OVERVIEW_RESULTS = 'getAllRegionalOverviewResults',
  GET_REGIONAL_OVERVIEW_RESULTS_V2 = 'getAllRegionalOverviewResultsV2',
  GET_REGIONAL_OVERVIEW_TECHNICIANS = 'getAllRegionalOverviewTechnicians'
}

export const DIGITAL_TRAP_NETWORKS_QUERY_KEY = 'digitalTrapNetworks';

export const DIGITAL_TRAP_NETWORK_TRAP_COUNTS_QUERY_KEY = 'digitalTrapNetworkTrapCounts';

export const NETWORK_NOTES_QUERY_KEY = 'digitalTrapNetworkNotes';

export const DIGITAL_TRAP_NETWORKS_REFERENCE_DATE = '2025-05-06';
export const DIGITAL_TRAPS_SOURCE = 'DIGITAL_TRAPS';
